// §11.9 / §9.1 — Calculator as an in-process app.
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp } from '@hangar/shared';
import { Calculator } from './Calculator';
import './calculator.css';

// One root per window (D-057): a `multiWindow` built-in must be able to tear down exactly the
// instance that closed.
const roots = new WeakMap<HTMLElement, Root>();

export const calculatorApp: InProcessApp = {
  id: 'calculator',
  name: 'Calculator',
  icon: { glyph: 'calculator', hue: 272 },
  keywords: ['maths', 'math', 'arithmetic', 'hex', 'binary', 'programmer'],
  window: { width: 340, height: 560, minWidth: 300, minHeight: 420, multiWindow: true },

  mount(container, api) {
    const root = createRoot(container);
    roots.set(container, root);
    root.render(<Calculator api={api} />);
  },

  unmount(container) {
    const root = roots.get(container);
    roots.delete(container);
    // React refuses to unmount synchronously from inside its own commit; the host layer calls
    // this from a store subscription, which is outside one.
    root?.unmount();
  },
};
